/** @jsx jsx */
import { useMemo } from 'react';
import { jsx } from '@emotion/core';
import { getNavLineStyles } from '../internal/styles';

var NavLine = function NavLine(_ref) {
  var status = _ref.status,
      mode = _ref.mode;
  return jsx("span", {
    css: useMemo(function () {
      return getNavLineStyles(mode);
    }, [mode]),
    "data-selected": status === 'selected' ? true : undefined
  });
};

export default NavLine;